import ShareContainer from 'containers/ShareContainer';
import React from 'react';

const Share = () => {
    return <ShareContainer />;
};

export default Share;
